export const CustomizedLabel = (props) => {
    const { x, y, value } = props;
    
    if (!value || value <= 0) return null;

    let text = `${value}`;
    if (value >= 1e9) text = `${(value / 1e9).toFixed(1).replace('.0', '')} M`;
    else if (value >= 1e6) text = `${(value / 1e6).toFixed(1).replace('.0', '')} jt`;
    else if (value >= 1e3) text = `${(value / 1e3).toFixed(0)} rb`;

    return (
        // foreignObject, agar dapat menyisipkan elemen di area chart
        <foreignObject x={x - 22} y={y - 26} width={44} height={20}> 
            <div style={{
                background: '#fff', 
                border: '1px solid #e2e8f0', 
                borderRadius: '4px',
                borderLeft: '3px solid #10b981', 
                boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                height: '100%', width: '100%',
                fontSize: '9px', fontWeight: '700', color: '#64748b',
                whiteSpace: 'nowrap',
                lineHeight: '1',
            }}>
                {text}
            </div>
        </foreignObject>
    );
};